import { render, staticRenderFns } from "./xianjin.vue?vue&type=template&id=31f1b768"
import script from "./xianjin.vue?vue&type=script&lang=js"
export * from "./xianjin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports